const legalQ = [
  {
    question: "What accounting evidence will I receive as an investor?",
    answer: "We will provide the income assignment contract, which can be downloaded from the property sheet."
  }
]

export default legalQ;